<ng-template #profile let-$profile="$profile">
  <div class="d-inline-block">
    <img class="profile-logo" src="/assets/logos/{{$profile.logo}}" alt="logo">
    <span class="px-2">{{$profile.name}}</span>
  </div>
</ng-template>

<div class="settings-form flex-fill">
  <div class="w-100 pe-1" style="max-height: 100px">
    <!-- PROFILE -->
    <div class="dropdown">
      <button class="btn btn-light dropdown-toggle mb-3 form-control" type="button" id="profileButton"
        data-bs-toggle="dropdown" aria-expanded="false">
        <ng-container [ngTemplateOutlet]="profile" [ngTemplateOutletContext]="{$profile: match.profile}" />
      </button>
      <ul class="dropdown-menu" aria-labelledby="profileButton">
        @for ($profile of profiles.profiles(); track $profile) {
          <li>
            <button class="dropdown-item" (click)="match.profile = $profile">
              <ng-container [ngTemplateOutlet]="profile" [ngTemplateOutletContext]="{$profile}" />
            </button>
          </li>
        }
      </ul>
    </div>

    <!-- TABS -->
    <ul class="nav nav-tabs nav-fill mb-2">
      @for ($tab of tabs; track $tab) {
        <li class="nav-item">
          <a class="nav-link"
            [class.active]="activeTab === $tab"
            aria-current="page"
            (click)="activeTab = $tab">
          {{$tab | titlecase}}</a>
        </li>
      }
    </ul>

    <div>
      @switch (activeTab) {
        @case ('teams') {
          <app-match-teams-editor />
        }
        @case ('rounds') {
          <app-match-rounds-editor />
        }
        @case ('profile') {
          <app-match-profile-editor />
        }
      }
    </div>

  </div>
</div>
